<nz-card>
  <h2>{{ 'ACCOUNT_SETTINGS.SECURITY.TITLE' | translate }}</h2>

  <nz-card nzType="inner" [nzTitle]="('ACCOUNT_SETTINGS.SECURITY.CHANGE_PASSWORD_TITLE' | translate)">
    <p class="section-description">{{ 'ACCOUNT_SETTINGS.SECURITY.CHANGE_PASSWORD_DESCRIPTION' | translate }}</p>
    <app-change-password></app-change-password>
  </nz-card>
</nz-card>
